<script lang="ts">
    import {router} from 'tinro';

    import List, {Item, Graphic, Separator, Text, PrimaryText, SecondaryText} from '@smui/list'
    import Textfield from '@smui/textfield'
    import Icon from '@smui/textfield/icon'

    import StreamerEditor from './StreamerEditor.svelte'

    import type {ReadyList, Streamer} from './jmdb'
    import {deep_copy, newId, streamer_list } from "./jmdb"
    
    export let streamer_id: string | undefined = undefined

    let newGroupSelected = false
    $: newGroupSelected = (streamer_id == newId.toString())

    let filterText = ''
    let selectedStreamers: Streamer | undefined
    let streamer_list_sorted: ReadyList<Streamer>

    streamer_list.fetch()
    $: streamer_list_sorted = {ready: $streamer_list.ready, data: $streamer_list.data.map(v=>v).sort((a, b) => a.name.localeCompare(b.name))}     


    let emptyStreamer: Streamer = {id: newId, name: '', nid: "Not yet assigned", sid: ''}
    $: selectedStreamers = newGroupSelected ? emptyStreamer : (streamer_list_sorted.data.find((v) => v.id == Number(streamer_id)) || undefined)

    
</script>


<div class="row">
    <div class="col-md-3">
        <div style="display: flex; flex-wrap: nowrap;">
            <Textfield withLeadingIcon label="Find" bind:value={filterText} >
                <Icon class="material-icons">search</Icon>
            </Textfield>
        </div>

    </div>
</div>
<div class="row">
    <div class="col-md-3 user-list">
        {#if !streamer_list_sorted.ready}
            Loading...
        {:else}
            <List singleSelection>
                {#each streamer_list_sorted.data as actor}
                {#if (!filterText || actor.name.toLowerCase().indexOf(filterText.toLowerCase()) != -1)}
                <Item selected={actor.id == Number(streamer_id)}>
                    <a class="divLink" href="/mgr/streamers/{actor.id}">&nbsp;</a>
                    <Text>{actor.name}</Text>
                </Item>
                <Separator />
                {/if}
                {/each}
            </List>
            <List singleSelection>
                <Item selected={newGroupSelected}>
                    <a class="divLink" href="/mgr/streamers/{newId}">&nbsp;</a>
                    <Graphic class="material-icons">add</Graphic>
                    <Text>New streamer</Text>
                </Item>
            </List>
        {/if}
    </div>
    <div class="col-md-9">
        {#if !selectedStreamers }
            Nothing is selected
        {:else}
            {#key selectedStreamers}
            <StreamerEditor streamer={deep_copy(selectedStreamers)}/> 
            {/key}
        {/if}
    </div>

</div>